import { css } from '@emotion/react'
import {
  CornerRadius,
  gemVar,
  LineWeight,
  Spacing,
  ThemedColors,
  ZIndex,
  Typography,
} from '@opallabs/gem'

const rootSelector = 'lapidary-multitoken-select'

export const selectors = {
  root: rootSelector,
  input: rootSelector + '-input',
  menuTrigger: rootSelector + '-menu-trigger',
  noSelectionText: rootSelector + '-no-selection-text',
  readOnly: rootSelector + '--readOnly',
}

export const stateSelectors = {
  isPositioned: 'is-positioned',
} as const

export const mainContainer = css({
  position: 'relative',
  borderRadius: CornerRadius.Small,

  '&:hover': {
    backgroundColor: gemVar(ThemedColors.Surface2),
  },

  [`&:not(.${selectors.readOnly}):focus,  &:not(.${selectors.readOnly}):focus-within`]:
    {
      [`.${selectors.input}`]: {
        borderColor: gemVar(ThemedColors.StrokePrimary2),
      },
      [`.${selectors.menuTrigger}`]: {
        opacity: 1,
        cursor: 'pointer',
      },
      [`.${selectors.noSelectionText}`]: {
        display: 'none',
      },
    },

  '.lapidary-token': {
    ...Typography.T500,
    backgroundColor: gemVar(ThemedColors.Surface2),
    borderColor: gemVar(ThemedColors.StrokeSecondary1),
    padding: Spacing.XS,

    '&:hover, &:focus, &:active': {
      backgroundColor: gemVar(ThemedColors.Primary2),
      borderColor: gemVar(ThemedColors.StrokePrimary1),
    },
  },
  '.lapidary-pill': {
    maxHeight: Spacing.M,
  },
})

export const trigger = css({
  opacity: 0,
  cursor: 'default',
})

export const noSelectedText = css({
  color: gemVar(ThemedColors.TextSecondary),
})

export const inputContainer = css({
  alignItems: 'center',
  borderStyle: 'solid',
  borderWidth: LineWeight.Small,
  borderColor: 'transparent',
  borderRadius: CornerRadius.Small,
  display: 'flex',
  flexWrap: 'wrap',
  gap: Spacing.S,
  padding: Spacing.S,
  position: 'relative',
})

export const menu = css({
  insetBlockStart: 0,
  insetInlineStart: 0,
  position: 'fixed',
  visibility: 'hidden',
  zIndex: ZIndex.Shroud.Popover,

  [`&.${stateSelectors.isPositioned}`]: {
    visibility: 'visible',
  },
})

export const token = css({
  maxHeight: Spacing.L,
  overflow: 'hidden',
  textWrap: 'nowrap',

  span: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
})
